var map = {
	"./images/rainbow/croped/Fries.png": 41,
	"./images/rainbow/croped/Milkshakes.png": 377,
	"./images/rainbow/croped/New folder/Fries.png": 512,
	"./images/rainbow/croped/New folder/MilkShake.png": 492,
	"./images/rainbow/croped/New folder/brownie.png": 842,
	"./images/rainbow/croped/New folder/brownie.zip": 723,
	"./images/rainbow/croped/New folder/brushchetta.png": 849,
	"./images/rainbow/croped/New folder/bunmaska.png": 690,
	"./images/rainbow/croped/New folder/burger.png": 981,
	"./images/rainbow/croped/New folder/coffee.png": 178,
	"./images/rainbow/croped/New folder/coldBeverage.png": 914,
	"./images/rainbow/croped/New folder/final-web-logo.png": 56,
	"./images/rainbow/croped/New folder/iceTea.png": 718,
	"./images/rainbow/croped/New folder/maggie.png": 976,
	"./images/rainbow/croped/New folder/milshake.png": 334,
	"./images/rainbow/croped/New folder/mocktail.png": 993,
	"./images/rainbow/croped/New folder/nachos.png": 191,
	"./images/rainbow/croped/New folder/pasta.png": 971,
	"./images/rainbow/croped/New folder/pizza.png": 570,
	"./images/rainbow/croped/New folder/roll.png": 306,
	"./images/rainbow/croped/New folder/sandwich.png": 67,
	"./images/rainbow/croped/New folder/tea.png": 840,
	"./images/rainbow/croped/brownie.png": 777,
	"./images/rainbow/croped/brushchetta.png": 320,
	"./images/rainbow/croped/bunmaska.png": 882,
	"./images/rainbow/croped/burger.png": 826,
	"./images/rainbow/croped/coffee.png": 912,
	"./images/rainbow/croped/coldBeverage.png": 593,
	"./images/rainbow/croped/final-web-logo.png": 23,
	"./images/rainbow/croped/iceTea.png": 833,
	"./images/rainbow/croped/maggie.png": 734,
	"./images/rainbow/croped/mocktail.png": 632,
	"./images/rainbow/croped/nachos.png": 157,
	"./images/rainbow/croped/pasta.png": 271,
	"./images/rainbow/croped/pizza.png": 57,
	"./images/rainbow/croped/roll.png": 388,
	"./images/rainbow/croped/sandwich.png": 907,
	"./images/rainbow/croped/tea.png": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 922;